import React, { useEffect, useState } from "react";
import { ROUTE } from "../../route/Route";
import BreadCrumb from "../breadcrumb/BreadCrumb";
import SeoAdd from "../Seo/SeoAdd";
import { useTranslation } from "react-i18next";
import MyAccount from "./MyAccount";
import { ProfileTabEnum } from "./ProfileTabEnum";
import EditProfile from "./EditProfile";
import TermsCondition from "./TermsCondition";
import FaqTab from "./FaqTab";
import PaymentHistory from "./PaymentHistory";
import FamilyMember from "./FamilyMember";
import ManageAddress from "./ManageAddress";
import DownloadReport from "./DownloadReport";
import MyOrder from "./MyOrder";
import TabLink from "./Component/TabLink";
import { dashboardAction, profileAction } from "../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import { getUser } from "../../constant/utils";
import { useLocation, useHistory, useParams } from "react-router-dom";
import { setBookingDataResponse } from "../../redux/checkout/reducer";
import ActivityLogs from "./ActivityLogs";
import LoadingScreen from "../LodingScreen";

function MyProfile() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { state } = useLocation<any>();
  const USER: any = getUser();
  const { slug }: { slug: string } = useParams();
  const [tab, setTab] = useState<ProfileTabEnum>(ProfileTabEnum.MyAccount);
  const profileData: any = useSelector((state: any) => (state.profile.profileData ? state.profile.profileData : {}));
  const bookingData: any = useSelector((state: any) => (state.checkout.bookingData ? state.checkout.bookingData : {}));
  const commonLoading: any = useSelector((state: any) => (state.common.loader ? state.common.loader : false));
  const patientData: any = useSelector((state: any) =>
    state.profile.patientList ? state.profile.patientList?.[0] : {}
  );
  const handleTab = (e: React.MouseEvent<HTMLLIElement, MouseEvent>, newTab: ProfileTabEnum) => {
    e.preventDefault();
    setTab(newTab);
    updateUrl(newTab);
  };

  const handleClick = (newTab: ProfileTabEnum) => {
    setTab(newTab);
    updateUrl(newTab);
  };

  useEffect(() => {
    if (bookingData?.isBookingEdit) {
      localStorage.removeItem("editBooking");
      localStorage.removeItem("CartData");
      dispatch(setBookingDataResponse({}));
    }

    const pathToTab: { [key: string]: ProfileTabEnum } = {
      "": ProfileTabEnum.MyAccount,
      bookings: ProfileTabEnum.MyOrder,
      members: ProfileTabEnum.FamilyMember,
      address: ProfileTabEnum.ManageAddress,
      "payment-history": ProfileTabEnum.PaymentHistory,
      faqs: ProfileTabEnum.Faqs,
      "terms-conditions": ProfileTabEnum.Terms,
      "activity-logs": ProfileTabEnum.ActivityLogs,
      "edit-profile": ProfileTabEnum.EditProfile,
    };

    const currentTab = pathToTab[slug] || ProfileTabEnum.MyAccount;
    setTab(currentTab);

    return () => {
      window.history.replaceState({}, "");
    };
  }, [dispatch, slug, bookingData]);

  useEffect(() => {
    switch (tab) {
      case ProfileTabEnum.MyAccount:
        dispatch(profileAction.getProfileAction({}));
        dispatch(profileAction.orderListAction({}));
        dispatch(profileAction.patientListAction({}));
        break;
      case ProfileTabEnum.MyOrder:
        break;
      case ProfileTabEnum.FamilyMember:
        dispatch(profileAction.profileMasterAction({}));
        dispatch(profileAction.patientListAction({}));
        break;
      case ProfileTabEnum.ManageAddress:
        dispatch(profileAction.cityListAction({}));
        dispatch(profileAction.stateListAction({}));
        dispatch(profileAction.addressListAction({}));
        break;
      case ProfileTabEnum.PaymentHistory:
        break;
      case ProfileTabEnum.Faqs:
        dispatch(dashboardAction.getFaqAction({}));
        break;
      case ProfileTabEnum.Terms:
        dispatch(profileAction.termConditionAction({}));
        break;
      case ProfileTabEnum.ActivityLogs:
        dispatch(profileAction.userActivityLogAction({}));
        break;
      case ProfileTabEnum.EditProfile:
        dispatch(profileAction.profileMasterAction({}));
        break;
      default:
        break;
    }
  }, [dispatch, tab]);

  const handleUpdate = (data: any) => {
    if (patientData?.pid) {
      dispatch(profileAction.updatePatientAction({ ...data, pid: patientData?.pid }, () => onSuccessAddMember()));
    } else {
      dispatch(profileAction.createPatientAction(data, () => onSuccessAddMember()));
    }
  };
  function onSuccessAddMember() {
    if (bookingData?.selectedMember?.pid == patientData?.pid) {
      dispatch(
        setBookingDataResponse({
          ...bookingData,
          tab: "member",
          selectedMember: undefined,
          PaymentMode: "",
        })
      );
    }
    dispatch(profileAction.getProfileAction({}));
  }

  const updateUrl = (newTab: ProfileTabEnum) => {
    let newPath = "/my-profile";
    switch (newTab) {
      case ProfileTabEnum.MyAccount:
        newPath = "/my-profile";
        break;
      case ProfileTabEnum.MyOrder:
        newPath = "/my-profile/bookings";
        break;
      case ProfileTabEnum.FamilyMember:
        newPath = "/my-profile/members";
        break;
      case ProfileTabEnum.ManageAddress:
        newPath = "/my-profile/address";
        break;
      case ProfileTabEnum.PaymentHistory:
        newPath = "/my-profile/payment-history";
        break;
      case ProfileTabEnum.Faqs:
        newPath = "/my-profile/faqs";
        break;
      case ProfileTabEnum.Terms:
        newPath = "/my-profile/terms-conditions";
        break;
      case ProfileTabEnum.ActivityLogs:
        newPath = "/my-profile/activity-logs";
        break;
      case ProfileTabEnum.EditProfile:
        newPath = "/my-profile/edit-profile";
        break;
      default:
        newPath = "/my-profile";
        break;
    }
    history.push(newPath);
  };

  const tabData: any[] = [
    {
      label: "My Bookings",
      tabName: ProfileTabEnum.MyOrder,
      icon: "/assets/img/my-profile/profile-module1.png",
    },
    {
      label: "Family Members",
      tabName: ProfileTabEnum.FamilyMember,
      icon: "/assets/img/my-profile/profile-module3.png",
    },
    {
      label: "Manage Addresses",
      tabName: ProfileTabEnum.ManageAddress,
      icon: "/assets/img/my-profile/profile-module4.png",
    },
    {
      label: "Payment History",
      tabName: ProfileTabEnum.PaymentHistory,
      icon: "/assets/img/my-profile/profile-module5.png",
    },
    {
      label: "FAQ",
      tabName: ProfileTabEnum.Faqs,
      icon: "/assets/img/my-profile/profile-module6.png",
    },
    {
      label: "Terms & Conditions",
      tabName: ProfileTabEnum.Terms,
      icon: "/assets/img/my-profile/profile-module7.png",
    },
    {
      label: "Activity Logs",
      tabName: ProfileTabEnum.ActivityLogs,
      icon: "/assets/img/my-profile/profile-module7.png",
    },
  ];

  return (
    <>
      <SeoAdd slug={ROUTE.MYPROFILE} />
      <BreadCrumb page="My Profile" data={{ slug: "", path: "" }} />
      {profileData?.mobile_no && (
        <section
          className="my-profile-sec bg-gray pt-3"
          style={{ color: "#242424", fontFamily: "Poppins, sans-serif" }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-3">
                <div className="profile-sidebar profile-inbox">
                  <div className="profile_top_box">
                    <div className="pro-logo text-center">
                      <span className="text_name">
                        {profileData?.first_name?.length > 0 ? (
                          profileData?.first_name?.charAt(0)?.toUpperCase()
                        ) : (
                          <img src="/assets/img/user.png" alt="" className="icon_sidebar_profile" />
                        )}
                      </span>
                      <img src="/assets/img/my-profile/pro-header-bg.png" alt="" />
                    </div>
                    <div className="pro-info text-center">
                      <h3>
                        {`${profileData?.first_name || ""} ${profileData?.last_name || ""}`}
                        <img
                          src="/assets/img/my-profile/edit.png"
                          alt=""
                          className="ml-2 cursor-pointer scale_picon"
                          onClick={(e: any) => handleTab(e, ProfileTabEnum.EditProfile)}
                        />
                      </h3>
                      <p>{profileData?.email_id}</p>
                      <p>{`+91 ${profileData?.mobile_no || ""}`}</p>
                    </div>
                  </div>
                  <div className="profile-module">
                    <ul>
                      {tabData &&
                        tabData?.map((ele: any, idx: number) => (
                          <TabLink
                            key={idx}
                            classStyle={tab === ele?.tabName ? "active_profile_Tab" : ""}
                            onClick={(e: any) => handleTab(e, ele?.tabName)}
                            icon={ele?.icon}
                            label={ele?.label}
                          />
                        ))}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-9">
                {ProfileTabEnum.MyAccount === tab && <MyAccount handleClick={handleClick} />}
                {ProfileTabEnum.EditProfile === tab && <EditProfile handleUpdate={handleUpdate} />}
                {ProfileTabEnum.MyOrder === tab && <MyOrder />}
                {ProfileTabEnum.DownloadReport === tab && <DownloadReport />}
                {ProfileTabEnum.ManageAddress === tab && <ManageAddress />}
                {ProfileTabEnum.FamilyMember === tab && <FamilyMember />}
                {ProfileTabEnum.PaymentHistory === tab && <PaymentHistory />}
                {ProfileTabEnum.Faqs === tab && <FaqTab />}
                {ProfileTabEnum.Terms === tab && <TermsCondition />}
                {ProfileTabEnum.ActivityLogs === tab && <ActivityLogs />}
              </div>
            </div>
          </div>
        </section>
      )}
      <div className="home-coll-whyonc pt-3"></div>
    </>
  );
}

export default MyProfile;
